import React from "react";

const highlights = [
 "🚀 End-to-end Full-Stack Development using React, React Native, Node.js, Express, and TypeScript.",
"📱 Cross-platform Mobile App Development for Android & iOS and deploying to Appstore and Playstore.",
"🌐 Modern Web Application Development with responsive, accessible, and scalable UI.",
"🔗 Secure REST API Development and third-party service (Payment Gateway/ Maps, ..etc) integrations.",
"⚡ Performance Optimization for fast, reliable, and scalable applications.",
"🏗️ Clean Architecture with reusable components and maintainable codebases.",
"☁️ Cloud Deployment and Backend Integration using AWS, MongoDB, and PostgreSQL.",
"🤝 Product-focused development, partnering with clients from idea validation to production launch."
];

const stack = [
  "JavaScript",
  "React",
  "React Native",
  "Node.js",
  "Express",
  "MongoDB",
  "Redux",
  "MySQL",
  "GraphQL",
  "RESTApi",
];

function AboutContent() {
  return (
    <section className="about-section">
      <div className="section-shell about-grid">
        <div className="glass-card about-card">
          <span className="eyebrow">About Me</span>
          <h2>
            Senior Software Engineer building elegant digital experiences.
          </h2>
          <p>
            I’m <strong>Siddaiah M</strong>, based in <span>Bangalore</span>{" "}
            with <span>6+ years of experience</span>{" "}
            building high-performance web and mobile applications. Throughout my
            career, I've worked with organizations including{" "}
            <span>Hy-Vee India</span>, <span>Orxa Energies</span>, and{" "}
            <span>MountBlue Technologies</span>, delivering customer-focused
            products from concept to production.
          </p>
          <p>
            I specialize in <span>React</span>, <span>React Native</span>,{" "}
            <span>TypeScript</span>, <span>Node.js</span>, <span>MongoDB</span>,
            full-stack development for web and mobile products, with expertise
            in designing scalable applications, reusable component libraries,
            and intuitive user experiences. I enjoy solving complex engineering
            challenges, optimizing application performance, and collaborating
            with cross-functional teams to build products that are both reliable
            and delightful to use. Whether it's developing enterprise platforms,
            launching startup products, or mentoring fellow engineers, I'm
            passionate about writing clean, maintainable code and creating
            technology that makes a meaningful impact.
          </p>
        </div>

        <div className="glass-card meta-card">
          <span className="eyebrow">Highlights</span>
          <ul className="highlight-list">
            {highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="glass-card stack-card">
          <span className="eyebrow">Tech Stack</span>
          <div className="chip-row">
            {stack.map((item) => (
              <span className="chip" key={item}>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutContent;
